// Resolves the deployment base path. The Dockerfile entrypoint replaces
// /__BASE_PATH_PLACEHOLDER__ in index.html with "/" or "/v2" before the SPA
// loads. In dev (Vite serves index.html directly) the placeholder is never
// substituted — fall back to "/" so router and auth flows behave normally.
export function getBasePath() {
  const bp = typeof window !== 'undefined' ? window.__BASE_PATH__ : undefined;
  if (!bp || bp.includes('PLACEHOLDER')) return '/';
  return bp;
}

// Origin + base path with trailing slash, suitable for Auth0 returnTo / redirect_uri.
export function getBaseOriginUrl() {
  const bp = getBasePath();
  return bp === '/' ? `${window.location.origin}/` : `${window.location.origin}${bp}/`;
}
